import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatINR } from "@/context/NetWorthContext";
import { IndianRupee } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { NetWorthRow } from "@/components/PersonDialog";
import { t } from "@/lib/i18n";

export const ProfileNetWorth = ({ me, persons }) => {
  const [pid, setPid] = useState(me.person_id);
  const [pending, setPending] = useState([]);
  const loadPending = useCallback(() => api.get("/networth-requests").then(({ data }) => setPending(data)).catch(() => setPending([])), []);
  useEffect(() => { loadPending(); }, [loadPending]);
  const mine = pending.find((r) => r.mine && r.person_id === pid);
  const others = persons.filter((x) => x.person_id !== me.person_id && x.status !== "pending").sort((a, b) => a.name.localeCompare(b.name));
  const p = pid === me.person_id ? me : others.find((x) => x.person_id === pid) || me;
  return (
    <section className="rounded-3xl border border-[#C59B27]/50 bg-white p-6 sm:p-7 space-y-4" data-testid="profile-networth-panel">
      <div>
        <h2 className="font-serif text-2xl font-semibold flex items-center gap-2"><IndianRupee className="w-5 h-5 text-[#C59B27]" />{t("Add or update net worth")}</h2>
        <p className="text-sm text-[#52635B] mt-1">{t("Choose yourself or any relative. Changes go live after 3 approvals.")}</p>
      </div>
      <Select value={pid} onValueChange={setPid}>
        <SelectTrigger className="h-11 rounded-xl max-w-md" data-testid="profile-networth-person-select"><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-72">
          <SelectItem value={me.person_id} data-testid="profile-networth-option-me">{me.name} ({t("me")})</SelectItem>
          {others.map((x) => <SelectItem key={x.person_id} value={x.person_id} data-testid={`profile-networth-option-${x.person_id}`}>{x.name}</SelectItem>)}
        </SelectContent>
      </Select>
      {mine && <p className="text-sm rounded-xl bg-[#C59B27]/10 text-[#8A6A12] px-3 py-2" data-testid="profile-networth-pending">{t("Waiting for approval")}: {formatINR(mine.amount)} ({mine.approvals}/{mine.needed})</p>}
      <dl className="max-w-2xl"><NetWorthRow key={p.person_id} p={p} onSent={loadPending} /></dl>
    </section>
  );
};
